import gql from 'graphql-tag';

export default gql`
query getThemeNameByThemeId($themeId: Int!) {
  themes_by_pk(theme_id: $themeId) {
    name
  }
}
`;
